<!-- for file upload  -->
<div class="container" style="margin-top: 100px;" *ngIf="currentDisplay == 1" >
    <div class="row">
        <div class="col-md-9 mx-auto">
            <button class="btn _btn float-right mb-2" (click)="goToWatch()"> 
                <span class="fa fa-arrow-left" *ngIf="!loader"></span> 
                <span class="spinner-border spinner-border-sm" *ngIf="loader" role="status" aria-hidden="true"></span>
                View Files
            </button>
            <p class="clear-fix clearfix"></p>
            <div class="image-upload-wrap">
                <div style="color: black; font-size: 15px;" class="ml-3 mt-2">
                   Total: {{fileUploadedTotal}}
                </div>
                <input class="file-upload-input" type='file' multiple (change)="upload($event)" />
                <div class="drag-text">
                    <div>Drag and drop a the file downloaded here</div>
                </div>
            </div>
            <div class="mt-2">
                <button [disabled]="fileUploadedTotal == 0" mat-raised-button color="primary" (click)="onUpload()">Upload <span class="ml-3 fa fa-upload"></span></button>
            </div>
        </div>
    </div>
</div>
<!-- viewing the video -->
<div class="container-fluid" *ngIf="currentDisplay == 0" style="margin-top: 50px;">
    <div class="row">
        <div class="col-12">
            <button class="btn _btn ml-4 mt-3 float-right" (click)="goBackToUpload()"><span class="fa fa-arrow-left"></span> New Upload</button>
            <p class="clear-fix clearfix"></p>
            <div class="row justify-content-start p-4">
                <div class="col-md-4 mb-4" *ngFor="let item of fileResource" >
                    <div class="card border-0 shadow">
                        <mat-video [keyboard]="false" #video src="{{item.path}}"></mat-video>
                        <p class="p-2">{{item.title}}</p>
                    </div>
                </div>
                <div class="p-3 shadow col-7 mx-auto" align="center" *ngIf="fileResource.length == 0">
                    <h3>No downloaded video found</h3>
                    <button mat-raised-button color="primary" (click)="goBackToUpload()">Upload one</button>
                </div>
            </div>
        </div>
    </div>
</div>